import { FieldDefinition } from "./fieldDefinitions";

export interface GDPRNoConsentPatientDto {
  patientId: number;
  patientLastName: string;
  patientFirstName: string;
  patientEmail: string;
  gdprVersion: string;
  dateSent: string | null;
  dateConfirmed: string | null;
  isAccepted: boolean;
}

export interface DocumentWithNoFileDto {
  documentId: number;
  patientId: number;
  patientLastName: string;
  patientFirstName: string;
  filePath: string | null;
  active: boolean;
  documentRemarks: string | null;
  examinationDate: string | null;
}

export interface PendingTasksDto {
  gdprNoConsentList: GDPRNoConsentPatientDto[];
  documentsWithNoFileList: DocumentWithNoFileDto[];
}

// 1. Fields για GDPR
export const gdprFields: FieldDefinition[] = [
  { name: "patientLastName", label: "Επώνυμο", type: "text" },
  { name: "patientFirstName", label: "Όνομα", type: "text" },
  { name: "patientEmail", label: "Email", type: "text" },
  { name: "gdprVersion", label: "Έκδοση GDPR", type: "text" },
  { name: "dateSent", label: "Ημ/νία Αποστολής", type: "date" },
  { name: "dateConfirmed", label: "Ημ/νία Επιβεβαίωσης", type: "date" },
  { name: "isAccepted", label: "Αποδοχή", type: "boolean" },
];

// 2. Fields για Documents
export const documentFields: FieldDefinition[] = [
  { name: "patientLastName", label: "Επώνυμο", type: "text" },
  { name: "patientFirstName", label: "Όνομα", type: "text" },
  { name: "documentRemarks", label: "Παρατηρήσεις Εγγράφου", type: "text" },
  { name: "examinationDate", label: "Ημ/νία Εξέτασης", type: "date" },
  { name: "active", label: "Ενεργό", type: "boolean" },
];
